/* eslint-disable */
import React, { CSSProperties, useMemo } from "react"
import { colors, css, fonts } from "../Styles"
import { AttentionTypes } from "./valueTypes";
import { CreateAttentionStyles } from "./attentionStyles";
import { t } from "i18next";

export enum NavLinkTypes {
  systemNavLink ="systemNavLink",
  tabNavLink = "tabNavLink",
  globalMenuNavLink = "globalMenuNavLink",
  systemStatusNavLink = "systemStatusNavLink",
  attentionListItem = "attentionListItem",
}
/* eslint-enable */

export const CreateNavLinkStyle = (
  navLinkType?: NavLinkTypes,
  attentionType?: AttentionTypes,
  focus_view?: boolean,
  overrides?: {
    baseButton?: CSSProperties,
    hoverStyles?: CSSProperties,
    iconStyles?: CSSProperties,
    hoverIconStyles?: CSSProperties,
    contentStyles?: CSSProperties,
    subContentStyles?: CSSProperties,
    hoverSubContentStyles?: CSSProperties,
    childrenStyles?: CSSProperties,
  }
) => {
  const merge = (defaultStyles: CSSProperties, overrideStyles?: CSSProperties) => ({
    ...defaultStyles,
    ...(overrideStyles || {}),
  });
  const { textColor, attentionColor } = CreateAttentionStyles(t, attentionType);
  
  let baseStyles = {} as CSSProperties
  let hoverStyles = {} as CSSProperties
  let iconStyles = {} as CSSProperties
  let contentStyles = {} as CSSProperties
  let subContentStyles = {} as CSSProperties
  let hoverSubContentStyles = {} as CSSProperties
  let hoverIconStyles = {} as CSSProperties
  let childrenStyles = {} as CSSProperties

  switch (navLinkType) {
    case NavLinkTypes.tabNavLink:
      baseStyles = {
        ...css.navLink_baseStyles,
        ...fonts.fontSize4,
        width: "fit-content",
        height: "40px",
        backgroundColor: colors.greyDarkPrimary,
        borderRadius: "10px 10px 0px 0px",
        padding: "5px 10px 0px 10px",
        transition: "background-color 0.3s ease",
      }
      hoverStyles = {
        ...css.navLink_hoverStyles,
        height: "45px",
        padding: "0px 10px"
      }
      contentStyles = {
        ...css.navLink_contentStyles,
      }
      childrenStyles = {
        ...css.navLink_childrenStyles
      }
    break
    case NavLinkTypes.globalMenuNavLink:
      baseStyles = {
        ...css.navLink_baseStyles,
        ...fonts.fontSize4,
        width: "130px",
        height: "80px",
        padding: "10px",
        flexDirection: "column",
        justifyContent: "end",
        transition: "0.3s ease"
      }
      hoverStyles = {
        ...css.navLink_hoverStyles
      }
      hoverIconStyles = {
        filter: "brightness(1.5)"
      }
      contentStyles = {
        ...css.navLink_contentStyles,
        textAlign: "center"
      }
      childrenStyles = {
        ...css.navLink_childrenStyles,
        flexDirection: "column",
        gap: "4px"
      }
      break
    case NavLinkTypes.systemStatusNavLink:
      baseStyles = {
        ...css.navLink_baseStyles,
        ...fonts.fontSize4,
        width: "fit-content",
        height: "fit-content",
        padding: "5px 10px",
        borderRadius: "8px"
      }
      contentStyles = {
        ...css.navLink_contentStyles,
        textAlign: "center"
      }
      break
      case NavLinkTypes.attentionListItem:
        baseStyles = {
          ...css.navLink_baseStyles,
          ...(focus_view ? fonts.fontSize3 : fonts.fontSize4),
          width: "100%",
          height: focus_view ? "60px" : "50px",
          overflow: "hidden",
          transition: "0.3s ease",
          justifyContent: "left",
          border: "3px solid " + attentionColor,
          backgroundColor: colors.greyDarkSecondary,
        }
        hoverStyles = { 
          ...css.navLink_hoverStyles,
          backgroundColor: focus_view ? colors.greyDarkSecondary : attentionColor,
        }
        contentStyles = {
          ...css.navLink_contentStyles,
          textAlign: "left"
        }
        subContentStyles = {
          ...fonts.textShadow, 
          ...(focus_view ? fonts.fontSize3 : fonts.fontSize4),
          ...fonts.paragraph,
          color: colors.greyPrimary,
          textAlign: "left",
          transition: "0.3s ease"
          }
        hoverSubContentStyles = {
          color: focus_view ? colors.greyPrimary : colors.greyLightTertiary,
        }
        childrenStyles = {
          ...css.navLink_childrenStyles,
          gap: "0px"
        }
        break
    case NavLinkTypes.systemNavLink:
      baseStyles = {
        ...css.navLink_baseStyles,
        ...(focus_view ? fonts.fontSize3 : fonts.fontSize4),
        width: "100%",
        height: focus_view ? "60px" : "50px",
        padding: "0px 10px",
        transition: "0.3s ease",
        justifyContent: "left"
      }
      hoverStyles = { 
        ...css.navLink_hoverStyles
      }
      contentStyles = {
        ...css.navLink_contentStyles,
        textAlign: "left"
      }
      subContentStyles = {
        ...fonts.textShadow, 
        ...(focus_view ? fonts.fontSize3 : fonts.fontSize4),
        ...fonts.paragraph,
        color: colors.greyPrimary,
        textAlign: "left",
        transition: "0.3s ease",
        pointerEvents: 'none',
        }
      hoverSubContentStyles = {
        color: colors.greyLightTertiary,
      }
      childrenStyles = {
        ...css.navLink_childrenStyles,
      }
      break
    default:
  }
  return {
    baseStyles: merge(baseStyles, overrides?.baseButton),
    hoverStyles: merge(hoverStyles, overrides?.hoverStyles),
    iconStyles: merge(iconStyles, overrides?.iconStyles),
    contentStyles: merge(contentStyles, overrides?.contentStyles),
    subContentStyles: merge(subContentStyles, overrides?.subContentStyles),
    hoverSubContentStyles: merge(hoverSubContentStyles, overrides?.hoverSubContentStyles),
    hoverIconStyles: merge(hoverIconStyles, overrides?.hoverIconStyles),
    childrenStyles: merge(childrenStyles, overrides?.childrenStyles)
  }
}